
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.68 3.68V2H2.32v1.68h13.36zm0 8.32V7H2.32v5h13.36zm0-11.68c.468 0 .86.17 1.172.508.312.313.468.703.468 1.172v10c0 .469-.156.872-.468 1.21-.313.313-.704.47-1.172.47H2.32c-.468 0-.86-.157-1.172-.47A1.724 1.724 0 01.68 12V2c0-.469.156-.86.468-1.172A1.528 1.528 0 012.32.32h13.36z","fill":"currentColor"}})])
          )
        }
      }
    